import { MessageType } from "../enums/MessageType";
import { DQOIItem } from "./DQOIItem";
import { SearchTarget } from "../enums/SearchTarget";

export class DQOIParam {
    id: string;
    code: string;
    dqoiItem: DQOIItem;
//    dqoiIndex: any;
    data: any;
    target: SearchTarget = SearchTarget.any;
}